const BREAKPOINTS = {
  DESKTOP: 1024,
  DESKTOP_LARGE: 1280
};

const SETTINGS = {
  THROTTLE_DELAY: 500,
  SEARCH_DEBOUNCE_DELAY: 300,
  FILTER_UPDATE_DELAY: 250,
  FILTER_DRAW_ANIMATION_TIME: 300,
  MOBILE_HEADER_STICKY_SCROLL_THRESHOLD: 100
};

const CART = {
  FORM_SUBMIT_TIMEOUT: 2000
};

const CLASSES = {
  TRANSLATE_X_0: 'translate-x-0',
  TRANSLATE_X_100: 'translate-x-full',
  OVERFLOW_HIDDEN: 'overflow-hidden',
  SCROLLABLE: 'overflow-y-auto'
};

const ARIAS = {
  EXPANDED: 'aria-expanded'
};

const SWIPER = {
  SLIDE_CLASS: '.swiper-slide',
  VIDEO_SLIDE: '[data-slide-video]'
};

const SELECTORS = {
  LOADING_SPINNER: '[data-loading-spinner]'
};

export {
  BREAKPOINTS,
  SETTINGS,
  CART,
  CLASSES,
  ARIAS,
  SWIPER,
  SELECTORS
};
